import { Link } from '~/components/Link';
import { ComponentProps } from 'react';
import { goToFullWebviewOnApp } from '~/services/app-interface';
import { useEnvironmentInfo, useIsClient } from '~/hooks';

import styles from './LinkByEnvironment.module.css';

const DISPLAY_NAME = 'LinkByEnvironment';

type Props = ComponentProps<typeof Link>;

/**
 * @description target이 `_blank`일 경우 새로운 탭/풀웹뷰가 열리고, `_self` 일 경우 현재 탭/풀웹뷰 안에서 이동합니다.
 */
export const LinkByEnvironment = ({ target = '_self', href: originalHref, onClick, ...props }: Props) => {
  const { isWebview } = useEnvironmentInfo();
  const { isClient } = useIsClient();

  if (target !== '_blank') {
    return <Link href={originalHref} {...props} onClick={onClick} />;
  }

  const href = isClient
    ? (typeof originalHref === 'string' ? new URL(originalHref, window.location.origin) : originalHref).href ?? ''
    : '';

  return (
    <Link
      href={href}
      {...props}
      onClick={(event) => {
        if (event.defaultPrevented) return;
        onClick?.(event);

        if (!isWebview) return;
        event.preventDefault();
        goToFullWebviewOnApp({ url: href }).go();
      }}
      target={isWebview ? '_self' : '_blank'}
      className={styles.container}
    />
  );
};

LinkByEnvironment.displayName = DISPLAY_NAME;
